import { render, staticRenderFns } from "./ShippingAddressForm.vue?vue&type=template&id=0cf50ad4&scoped=true"
import script from "./ShippingAddressForm.vue?vue&type=script&lang=js"
export * from "./ShippingAddressForm.vue?vue&type=script&lang=js"
import style0 from "./ShippingAddressForm.vue?vue&type=style&index=0&id=0cf50ad4&prod&lang=scss&scoped=true"
import style1 from "./ShippingAddressForm.vue?vue&type=style&index=1&id=0cf50ad4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf50ad4",
  null
  
)

export default component.exports